module.exports = __webpack_public_path__ + "img/oneRed.b90e5a89.jpg";